import { EMAIL_REGEX, tld as topLevelDomainWhitelist} from './constants'

export const validateEmail = (email) => {
  const emailSplit = email.split('@')
  const numberOfEmailParts = 2
  const minimumNumberOfDomains = 2

  // An email address has only two parts: the username part and the domain part
  if (emailSplit.length != numberOfEmailParts) return false

  const domainPart = emailSplit[1]
  const domainSplit = domainPart.split('.')

  // An email domain part should have at least one top-level domain and one second-level domain
  if (domainSplit.length < minimumNumberOfDomains) return false

  const topLevelDomain = domainSplit[domainSplit.length - 1]

  return EMAIL_REGEX.test(email) && topLevelDomainWhitelist.test(topLevelDomain)
}

export const isNumericString = (str) => {
  if (typeof str != 'string') return false
  return !isNaN(str) &&
         !isNaN(parseFloat(str))
}
